// useSpecificSize.ts
import { useEffect, useMemo, useState } from "react";

export const sideMenuSize = 200;
export const horizontalSpacing = 10;

function getWindowSize() {
  return {
    width: window.innerWidth,
    height: window.innerHeight,
    pixelRatio: window.devicePixelRatio
  };
}

export function useSpecificSize() {
  const [windowSize, setWindowSize] = useState(getWindowSize);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(getWindowSize());
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return useMemo(() => {
    const dynamicSideMenuSize = ((windowSize.width > windowSize.height) && ((windowSize.width / windowSize.pixelRatio) > 460)) ? 200 : 0;

    const availableScreenSize = windowSize.width - dynamicSideMenuSize;

    const contentSize = availableScreenSize > 1024 ? 1024 : availableScreenSize - 2*horizontalSpacing;

    return {
      fullScreenWidth: windowSize.width,
      fullScreenHeight: windowSize.height,
      availableScreenSize,
      contentSize,
      sideMenuSize: dynamicSideMenuSize,
      horizontalSpacing,
      pixelRatio: windowSize.pixelRatio
    };
  }, [windowSize]);
}